var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hotel-building-edit-view"},[_c('h1',{staticClass:"app-h1"},[_vm._v(" Добавление копуса в отель \""+_vm._s(_vm.hotelTitle)+"\" ")]),_c('hotel-building-form',{attrs:{"hotel-id":_vm.hotelId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }